<template>
    <v-alert
        v-if="paymentFailed" dark
        color="pink darken-1" dense v-ripple
        class="pointer" border="left"
        icon="mdi-credit-card-sync-outline"
        @click="goToChangePaymentMethod"
    >
        <div class="body-1 bolder">
            {{ title }}
        </div>
        <div class="bottom-text" v-if="nextIntentDate">
            {{ nextIntentDate }}
        </div>
        <div class="bottom-text">
            {{ $t('payment_failed_messages.contact_with_bank') }}
        </div>
        <div v-if="accountDisabled" class="bottom-text bolder">
            {{ accountDisabled }}
        </div>
    </v-alert>
</template>

<script>

export default {
    name: "SubscriptionStatus",
    computed: {
        currentSubscription(vm = this) {
            return vm.account?.stripeAccount?.currentSubscription || null
        },
        paymentFailed(vm = this) {
            if (!vm.currentSubscription) return false
            return Boolean(vm.currentSubscription.paymentFailed)
        },
        changePaymentRoute(vm = this) {
            return `${vm.accountType}.payment.edit`
        },
        showRedirect(vm = this) {
            return vm.$route.name !== vm.changePaymentRoute
        },
        title(vm = this) {
            let defaultMessage = vm.$t('payment_failed_messages.try_again_later')
            let failed = vm.account?.stripeAccount?.failedReason || ''
            if (!failed) return defaultMessage
            return vm.$te(`payment_failed_messages.${failed}`) ?
                vm.$t(`payment_failed_messages.${failed}`) :
                defaultMessage
        },
        nextIntentDate(vm = this) {
            let date = vm.account?.stripeAccount?.currentSubscription?.nextPaymentAttempt || null
            if (!date) return null
            let dateMoment = vm.$moment(date * 1000)
            if (dateMoment.isBefore()) return null
            let dateFormat = dateMoment.format(`D [${vm.$t('common.of')}] MMMM [${vm.$t('common.of_the')}] YYYY`)
            return vm.$t('payment_failed_messages.intent_date', {date: dateFormat})
        },
        accountDisabled(vm = this) {
            let today = vm.$moment();
            let daysUntilNextMonday = 1 - today.isoWeekday()
            if (daysUntilNextMonday < 0) daysUntilNextMonday += 7
            let nextMonday = today.add(daysUntilNextMonday, 'days')
            let formattedDate = nextMonday.format('DD-MM-YYYY')
            return vm.$t('payment_failed_messages.account_disabled', {date: formattedDate})
        }
    },
    methods: {
        goToChangePaymentMethod() {
            const vm = this
            if (!vm.showRedirect) return;
            vm.$router.push({name: vm.changePaymentRoute})
        }
    }
}
</script>

<style scoped>
.bottom-text {
    line-height: 15px;
    font-size: .75em !important;
    margin: 5px 0;
}
</style>